import chroma from "chroma-js";

export const COLORS = {
  // WHITES
  WHITE1000: "#FFFFFF",
  WHITE1000_24: "#FFFFFF3D",
  WHITE1000_12: "#FFFFFF1E",
  WHITE1000_06: "#FFFFFF0F",
  WHITE1000_04: "#FFFFFF0A",
  WHITE966: "#FCFBFA",
  WHITE948: "#F9F9F9",
  WHITE933: "#F9F7F6",
  WHITE906: "#F5F4F3",
  WHITE847: "#EDEDED",
  WHITE847_48: "#EDEDED7A",
  WHITE755: "#E3E1DE",
  WHITE632: "#D1D0CF",
  // NEUTRALS
  NEUTRAL470: "#B8B6B4",
  NEUTRAL396: "#A9A9A7",
  NEUTRAL296: "#949492",
  NEUTRAL196: "#7C7A79",
  NEUTRAL118: "#665F5C",
  NEUTRAL095: "#5A5653",
  NEUTRAL074: "#504C49",
  NEUTRAL063: "#474747",
  NEUTRAL021: "#4D4D4D",
  // BLACKS
  BLACK040: "#383838",
  BLACK029: "#2F2F2F",
  BLACK020: "#262626",
  BLACK012: "#1C1C1C",
  BLACK000: "#000000",
  BLACK000_64: "#000000A3",
  BLACK000_48: "#0000007A",
  BLACK000_32: "#00000051",
  BLACK000_24: "#0000003D",
  BLACK000_16: "#00000028",
  BLACK000_12: "#0000001E",
  BLACK000_06: "#0000000F",
  BLACK000_04: "#0000000A",
  // PINKS
  PINK459: "#EC9FB2",
  PINK298: "#C28392",
  // REDS
  RED234: "#EC4B4B",
  RED234_12: "#EC4B4B1E",
  RED199: "#DB4646",
  RED153: "#C23E3E",
  RED153_12: "#C23E3E1E",
  RED124: "#B03839",
  // ORANGES
  ORANGE487: "#F5A962",
  ORANGE323: "#E08159",
  ORANGE315: "#C98B51",
  ORANGE263: "#EA6134",
  ORANGE257: "#E16540",
  ORANGE257_64: "#E16540A3",
  ORANGE257_32: "#E1654051",
  ORANGE257_16: "#E1654028",
  ORANGE257_12: "#E165401F",
  ORANGE257_06: "#E165400F",
  ORANGE245: "#D6683A",
  ORANGE160: "#B55133",
  ORANGE160_48: "#B551337A",
  ORANGE160_32: "#B5513351",
  ORANGE160_12: "#B551331F",
  ORANGE049: "#72240D",
  ORANGE049_64: "#72240DA3",
  // YELLOWS
  YELLOW742: "#F0DEB7",
  YELLOW655: "#F9CE6F",
  YELLOW628: "#D6CFC2",
  YELLOW628_48: "#D6CFC27A",
  YELLOW628_06: "#D6CFC20F",
  YELLOW559: "#F9BB32",
  YELLOW559_16: "#F9BB3228",
  YELLOW422: "#DBA52D",
  // TODO: This is the same as YELLOW559
  YELLOW369: "#F9BB32",
  YELLOW369_16: "#F9BB3228",
  YELLOW073: "#5F4919",
  // GREENS
  GREEN606: "#B5D96F",
  GREEN428: "#4CC489",
  GREEN312: "#86A152",
  GREEN311: "#4EA87B",
  GREEN271: "#549C79",
  GREEN253: "#379E0E",
  GREEN253_12: "#379E0E1E",
  GREEN163: "#3A7D5B",
  GREEN128: "#28730A",
  GREEN128_12: "#28730A1E",
  // BLUES
  BLUE652: "#A8D9FF",
  BLUE652_32: "#A8D9FF51",
  BLUE546: "#73CDFF",
  BLUE414: "#7AAEFB",
  BLUE341: "#38ADB5",
  BLUE301: "#7897C4",
  BLUE271: "#468DF7",
  BLUE189: "#2B848A",
  BLUE178: "#3A74CC",
  BLUE137: "#4D6B82",
  BLUE137_48: "#4D6B827A",
  // PURPLES
  PURPLE412: "#A3A3FF",
  PURPLE374: "#C88FE2",
  PURPLE273: "#8787D4",
  PURPLE270: "#A574F4",
  PURPLE239: "#A275B8",
  PURPLE190: "#9765AE",
};

export const graphLight = {
  pink: COLORS.PINK459,
  red: COLORS.RED199,
  orange: COLORS.ORANGE257,
  orangeLight: COLORS.ORANGE487,
  yellow: COLORS.YELLOW655,
  green: COLORS.GREEN311,
  greenLight: COLORS.GREEN606,
  teal: COLORS.BLUE341,
  blue: COLORS.BLUE271,
  blueLight: COLORS.BLUE652,
  purple: COLORS.PURPLE412,
  purpleLight: COLORS.PURPLE374,
  otherData: COLORS.WHITE755,
};

export const graphDark: typeof graphLight = {
  pink: COLORS.PINK298,
  red: COLORS.RED124,
  orange: COLORS.ORANGE160,
  orangeLight: COLORS.ORANGE315,
  yellow: COLORS.YELLOW655,
  green: COLORS.GREEN163,
  greenLight: COLORS.GREEN312,
  teal: COLORS.BLUE189,
  blue: COLORS.BLUE178,
  blueLight: COLORS.BLUE546,
  purple: COLORS.PURPLE273,
  purpleLight: COLORS.PURPLE239,
  otherData: COLORS.NEUTRAL470,
};

export const graphScaleLight = [
  graphLight.orange,
  graphLight.blueLight,
  graphLight.yellow,
  graphLight.purple,
  graphLight.red,
  graphLight.teal,
  graphLight.orangeLight,
  graphLight.pink,
  graphLight.blue,
  graphLight.greenLight,
  graphLight.green,
  graphLight.purpleLight,
].map((color) => chroma(color).hex());

export const graphScaleDark = [
  graphDark.orange,
  graphDark.blueLight,
  graphDark.yellow,
  graphDark.purple,
  graphDark.red,
  graphDark.teal,
  graphDark.orangeLight,
  graphDark.pink,
  graphDark.blue,
  graphDark.greenLight,
  graphDark.green,
  graphDark.purpleLight,
].map((color) => chroma(color).hex());
